HiddenInput.defaultValue = null;
export default function HiddenInput() {
  return null;
}
